import React from 'react';
import produce from 'immer';

import { withStyles } from '@mui/styles';

import LoaderNew from '../../common/LoaderNew';
import DataAndMacro from './components/DataAndMacro';
import TrplSelect from '../../common/TrplControls/TrplSelect';
import ComponentWrapper from '../../common/ComponentWrapper';
import CommonStyles from '../../common/CommonStyles';
import { resizableXParent, ResizableStyles } from '../../common/ResizableFrames';

import { getUrlParameter, setUrlParameter } from '../../utils';

const styles = {
  filterInput: {
    border: 'none',
    width: '260px',
    maxWidth: '260px',
    maxHeight: '24px',
    minHeight: '24px',
    fontSize: '12px',
    color: '#4E4C4C',
    background: '#e8ebf5',
    '& .MuiInputBase-input': {
      paddingLeft: '5px',
    },
    '&:hover': {
      background: '#eeecf8',
    },
    '&:focus': {
      background: '#DBD9E7',
    },
  },
  filterTextarea: {
    width: '250px',
    border: 'none',
    fontSize: '12px',
    minHeight: '24px',
    maxHeight: '500px',
    padding: '4px 5px',
    resize: 'both',
    background: '#e8ebf5',
    '&:hover': {
      background: '#eeecf8',
    },
  },
  filterItemLabel: {
    display: 'flex',
    width: '130px',
    color: '#4E4C4C',
    fontSize: '12px',
    marginRight: '8px',
    flexDirection: 'row-reverse',
  },
  filterCheckboxGray: {
    padding: '0px',
    height: '16px',
    '& .MuiSvgIcon-root': {
      color: '#878787',
      fontSize: '18px',
    },
  },
  nothingFoundText: {
    display: 'flex',
    color: '#878787',
    fontSize: '12px',
    marginTop: '60px',
    justifyContent: 'center',
  },
  chatMsgImagesBlock: {
    display: 'flex',
    padding: '10px 0 10px 10px',
    marginTop: '10px',
    borderTop: '1px solid #fff',
  },
  chatMsgImageLink: {
    width: '75px',
    marginRight: '10px',
  },
  chatMsgImage: {
    width: '100%',
    outline: '2px solid coral',
    maxHeight: '100px',
  },
  chatMsgFilesBlock: {
    display: 'flex',
    flexDirection: 'column',
    padding: '10px 0 10px 10px',
    marginTop: '10px',
    borderTop: '1px solid #fff',
  },
  chatMsgFile: {
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    flexShrink: '0',
  },
  ...ResizableStyles,
  ...CommonStyles,
};

class FineTuningDatasetPage extends ComponentWrapper {
  state = {
    to: '', // 'midex_ops2@mlkwb.com',
    from: '',
    source: '',
    reply_to: '',
    start_id: 1,
    last_id: null,
    first_index: '',
    desc: '',
    limit: 10,
    searchValue: '',
    lastSentData: null,
    has_completion: '',
    has_classification: '',
    has_gpt_completion: '',
    has_gpt_classification: '',
    has_attachments: '',
    is_json_valid: '',
    has_table: '',
    is_text: '',
    is_html: '',
    body_contain: '',
    macro_contain: '',
    isDataLoading: false,
    total_msgs: 0,
    messagesData: [],
    frontFilteredMsgsData: [],
    finetune_template: '',
    finetune_classif: [],
  };

  componentDidMount() {
    const startId = getUrlParameter('start_id');
    const lastId = getUrlParameter('last_id');
    const limit = getUrlParameter('limit');
    const desc = getUrlParameter('desc');
    const to = getUrlParameter('to');

    const meta_query = ["finetune_template","finetune_classif","llm_models"];

    // if (startId || lastId || to) {
      const data = {
        desc: desc === 'false' ? false : desc ? desc : '',
        start_id: startId ? +startId : '',
        last_id: lastId ? +lastId : '',
        limit: limit ? limit : 10,
        to: to || '',
      };

      this.setState({
        ...data,
        //isDataLoading: true,
      });

      // this.postWithData({
      //   url: '/rest/get_msgs',
      //   data: {
      //     ...data,
      //     meta_query,
      //   },
      //   cb: (res) => {
      //     if (res._status === 'ok') {
      //       const { finetune_template, finetune_classif, llm_models } = res._meta_query;
      //       const finalMsgsData = this.filterMessagesOnClientSide(res.msgs);

      //       this.setState({
      //         llm_models,
      //         finetune_classif,
      //         finetune_template,
      //         lastSentData: data,
      //         isDataLoading: false,
      //         messagesData: res.msgs,
      //         total_msgs: res.total_msgs,
      //         frontFilteredMsgsData: finalMsgsData,
      //       });
      //     }
      //   },
      // });
    //} else {

      this.get({
        url: `/meta_query?meta_query=[${meta_query}]`,
        cb: (res) => {
          if (res) {
            const { finetune_template, finetune_classif, llm_models } = res._meta_query;
            this.setState({ finetune_template, finetune_classif, llm_models });
          }
        }
      });
    //}
  };

  // shouldComponentUpdate(nextProps, nextState) {
  //   return (
  //     this.state !== nextState
  //   );
  // };

  modifyJsonKeyVal = (key, val, finetune_val, msgId, cb) => {
    this.postWithData({
      url: '/rest/set_val_to_finetune_compl',
      data: {
        key,
        val,
        finetune_val,
      },
      cb: (res) => {
        if (res._status === 'ok') {
          const messageIndex = this.state.frontFilteredMsgsData.findIndex(mes => mes.id === msgId);

          const messagesData = produce(this.state.frontFilteredMsgsData, mutableMessagesData => {
            mutableMessagesData[messageIndex].finetune_compl = res.data;
          });

          if (cb) cb(res.data);

          this.setState({ frontFilteredMsgsData: messagesData });
        }
      }
    })
  };

  onSaveJsonToDB = (id, json, index, cb) => {
    this.postWithData({
      url: '/rest/upd_finetune_compl',
      data: {
        finetune_compl: json,
        id,
      },
      cb: (res) => {
        if (res._status === 'ok') {
          const messageIndex = this.state.messagesData.findIndex(mes => mes.id === res.msg.id);

          const messagesData = produce(this.state.messagesData, mutableMessagesData => {
            mutableMessagesData[messageIndex] = {...res.msg};
          });

          const frontFilteredMsgsData = produce(this.state.frontFilteredMsgsData, mutableMessagesData => {
            mutableMessagesData[index - 1] = {...res.msg};
          });
      
          this.setState({ frontFilteredMsgsData, messagesData });
          cb(false);
        }
      },
    });
  };

  onSendFilterBtnClick = () => {
    const {
      to,
      from,
      reply_to, 
      start_id,
      last_id,
      desc,
      limit,
      source,
      is_text,
      is_html,
      first_index,
      body_contain,
      macro_contain,
      has_completion,
      has_attachments,
      has_classification,
      has_gpt_completion,
      has_gpt_classification,
    } = this.state;

    if (to) setUrlParameter('to', to);
    if (desc === 'false' || desc) setUrlParameter('desc', desc);

    const data = {
      to,
      from,
      reply_to, 
      start_id: +start_id,
      last_id: +last_id || null,
      first_index: +first_index,
      desc: desc === 'false' ? false : desc,
      limit,
      source,
      is_text,
      is_html,
      body_contain,
      macro_contain,
      has_completion,
      has_attachments,
      has_classification,
      has_gpt_completion,
      has_gpt_classification,
    };

    this.postWithData({
      url: '/rest/get_msgs',
      data,
      cb: (res) => {
        if (res._status === 'ok') {
          const finalMsgsData = this.filterMessagesOnClientSide(res.msgs);

          this.setState({
            classif_stat: null,
            lastSentData: data,
            isDataLoading: false,
            messagesData: res.msgs,
            total_msgs: res.total_msgs,
            frontFilteredMsgsData: finalMsgsData,
          }, () => resizableXParent());
        } else this.setState({ isDataLoading: false });
      },
    });
  };

  filterMessagesOnClientSide = (messagesData) => {
    let newMessages = this.checkForJsonValid(messagesData);
    newMessages = this.filterMessagesByHasTable(newMessages);

    return newMessages;
  };

  checkForJsonValid = (messages) => {
    const { is_json_valid } = this.state;

    if (is_json_valid === '') return messages;

    return messages.filter(message => {
      if (is_json_valid === false) {
        if (!message.is_finetune_compl_valid && message.finetune_compl) return message;
      }
      if (is_json_valid === true) {
        if (message.is_finetune_compl_valid && message.finetune_compl) return message;
      }
      return null;
    });
  };

  filterMessagesByHasTable = (messages) => {
    const { has_table } = this.state;

    if (has_table === '') return messages;

    return messages.filter(message => has_table ? message.has_table : !message.has_table);
  };

  setFilterValueToState = (field, value) => {
    const { messagesData } = this.state;

    this.setState({ [field]: value }, () => {
      if (field === 'is_json_valid' || field === 'has_table') {
        const newMessages = this.filterMessagesOnClientSide(messagesData);
        this.setState({ frontFilteredMsgsData: newMessages });
      }
    });
  };

  sendClassification = (id, classif, cb) => {
    const data = {
      id,
      finetune_classif: classif,
    };

    this.postWithData({
      url: '/rest/upd_finetune_classif',
      data,
      cb: (res) => {
        if (res._status === 'ok') {
          const immutableMessages = produce(this.state.frontFilteredMsgsData, mutableMessagesData => {
            const messageIndex = this.state.frontFilteredMsgsData.findIndex(mes => mes.id === id);
            mutableMessagesData[messageIndex] = { ...mutableMessagesData[messageIndex], finetune_classif: classif };
          });

          this.setState({ frontFilteredMsgsData: immutableMessages });
        } 
        cb();
      },
    });
  };

  setSearchVal = (searchValue) => {
    this.setState({ searchValue });
  };

  changeFinetuneKey = () => {
    const { old_key, new_key } = this.state;

    const data = {
      old_key,
      new_key,
    };

    this.postWithData({
      url: '/rest/change_finetune_key',
      data,
      cb: () => {
        this.setState({ isChangingFinetuneKey: false });
      }
    });
  };

  getClassifStat = () => {
    const { to } = this.state;

    this.postWithData({
      url: '/rest/get_classif_stat',
      data: { email: to },
      cb: (res) => {
        this.setState({
          classif_stat: res.data,
          isClassifStatLoading: false,
        });
      }
    });
  }

  countTokens = (mesId, cb) => {
    this.get({
      url: `/rest/openai/get_tokens?id=${mesId}`,
      cb: (res) => {
        if (cb) {
          if (res._status === 'ok') cb(res.data);
          else cb(null);
        }
      },
      errorCb: () => {
        if (cb) cb(null);
      }
    });
  };

  render() {
    const {
      to,
      from,
      reply_to, 
      start_id,
      last_id,
      desc,
      limit,
      source,
      old_key,
      new_key,
      is_text,
      is_html,
      llm_models,
      total_msgs,
      first_index,
      body_contain,
      macro_contain, 
      has_completion,
      has_classification,
      has_gpt_completion,
      has_gpt_classification,
      has_attachments,
      is_json_valid,
      isDataLoading,
      messagesData,
      lastSentData,
      classif_stat,
      searchValue,
      has_table,
      finetune_classif,
      finetune_template,
      isClassifStatLoading,
      frontFilteredMsgsData,
      isChangingFinetuneKey,
    } = this.state;

    const {
      classes,
    } = this.props;

    return (
      <div className={`${classes.mt20}`} style={{ marginBottom: '120px' }}>
        <div className={`${classes.ml20} ${classes.flex}`}>
          <div
            className={`${classes.mb10} ${classes.inlineFlex} ${classes.p10}`}
            style={{ justifyContent: 'space-between', backgroundColor: '#fff' }}
          >
            <div style={{ width: '390px' }}>
              <div className={`${classes.alignCenter} ${classes.mb5} `}>
                <span className={classes.filterItemLabel}>source</span>
                <TrplSelect
                  margin="none"
                  values={['', 'EMAIL', 'SMS', 'FACEBOOK', 'TELEGRAM']}
                  onChange={(e) => this.setFilterValueToState('source', e.target.value)}
                  value={source}
                  formControlClassName={classes.filterInput}
                />
              </div>

              <div className={`${classes.mb5} ${classes.alignCenter}`}>
                <span className={classes.filterItemLabel}>to</span>
                <input
                  value={to}
                  name="to"
                  disabled={false}
                  className={`${classes.filterInput}`}
                  onChange={(e) => {
                    this.setFilterValueToState('to', e.target.value);
                  }}
                />
              </div>

              <div className={`${classes.mb5} ${classes.alignCenter}`}>
                <span className={classes.filterItemLabel}>from</span>
                <input
                  value={from}
                  name="from"
                  className={`${classes.filterInput}`}
                  onChange={(e) => {
                    this.setFilterValueToState('from', e.target.value);
                  }}
                />
              </div>

              <div className={`${classes.mb10} ${classes.alignCenter}`}>
                <span className={classes.filterItemLabel}>reply_to</span>
                <input
                  value={reply_to}
                  name="reply_to"
                  className={`${classes.filterInput}`}
                  onChange={(e) => {
                    this.setFilterValueToState('reply_to', e.target.value);
                  }}
                />
              </div>

              <div className={`${classes.mb5} ${classes.alignCenter}`}>
                <span className={classes.filterItemLabel}>start_id</span>
                <input
                  value={start_id}
                  name="start_id"
                  type={'number'}
                  className={`${classes.filterInput}`}
                  onChange={(e) => {
                    this.setFilterValueToState('start_id', +e.target.value);
                  }}
                />
              </div>

              <div className={`${classes.mb5} ${classes.alignCenter}`}>
                <span className={classes.filterItemLabel}>last_id</span>
                <input
                  value={last_id || ''}
                  name="last_id"
                  type={'number'}
                  className={`${classes.filterInput}`}
                  onChange={(e) => {
                    this.setFilterValueToState('last_id', +e.target.value);
                  }}
                />
              </div>

              <div className={`${classes.mb5} ${classes.alignCenter}`}>
                <span className={classes.filterItemLabel}>first_index</span>
                <input
                  value={first_index}
                  name="first_index"
                  type={'number'}
                  className={`${classes.filterInput}`}
                  onChange={(e) => {
                    this.setFilterValueToState('first_index', +e.target.value);
                  }}
                />
              </div>

              <div className={`${classes.alignCenter} ${classes.mb5}`}>
                <span className={classes.filterItemLabel}>limit</span>
                <input
                  value={limit}
                  name="limit"
                  type={'number'}
                  className={`${classes.filterInput}`}
                  onChange={(e) => {
                    this.setFilterValueToState('limit', +e.target.value);
                  }}
                />
              </div>

              <div className={`${classes.alignCenter} ${classes.mb10}`}>
                <span className={classes.filterItemLabel}>desc</span>
                <TrplSelect
                  margin="none"
                  complicatedValues
                  values={[
                    { title: '', value: '' },
                    { title: 'false', value: false },
                    { title: 'true', value: true },
                  ]}
                  onChange={(e) => {
                    this.setFilterValueToState('desc', e.target.value);
                  }}
                  value={desc}
                  formControlClassName={classes.filterInput}
                />
              </div>

              <div className={`${classes.alignCenter} ${classes.mb5}`}>
                <span className={classes.filterItemLabel}>is_text</span>
                <TrplSelect
                  margin="none"
                  complicatedValues
                  values={[
                    { title: '', value: '' },
                    { title: 'false', value: false },
                    { title: 'true', value: true },
                  ]}
                  onChange={(e) => this.setFilterValueToState('is_text', e.target.value)}
                  value={is_text}
                  formControlClassName={classes.filterInput}
                />
              </div>

              <div className={`${classes.alignCenter} ${classes.mb5}`}>
                <span className={classes.filterItemLabel}>is_html</span>
                <TrplSelect
                  margin="none"
                  complicatedValues
                  values={[
                    { title: '', value: '' },
                    { title: 'false', value: false },
                    { title: 'true', value: true },
                  ]}
                  onChange={(e) => this.setFilterValueToState('is_html', e.target.value)}
                  value={is_html}
                  formControlClassName={classes.filterInput}
                />
              </div>

              <div className={`${classes.alignCenter} ${classes.mb5}`}>
                <span className={classes.filterItemLabel}>body_contains</span>
                <textarea
                  className={`${classes.filterTextarea}`}
                  value={body_contain}
                  onChange={(e) => {
                    this.setFilterValueToState('body_contain', e.target.value)
                  }}
                />
              </div>

              <div className={`${classes.alignCenter} ${classes.mb10}`}>
                <span className={classes.filterItemLabel}>macro_contains</span>
                <textarea
                  className={`${classes.filterTextarea}`}
                  value={macro_contain}
                  onChange={(e) => {
                    this.setFilterValueToState('macro_contain', e.target.value)
                  }}
                />
              </div>

              <div className={`${classes.alignCenter} ${classes.mb5}`}>
                <span className={classes.filterItemLabel}>classification</span>
                <TrplSelect
                  margin="none"
                  stylesToItems={
                    {
                      'none': {fontStyle: 'italic', fontWeight: 550 },
                      'any': {fontStyle: 'italic', fontWeight: 550 },
                    }
                  }
                  values={['', 'none', 'any', ...finetune_classif]}
                  onChange={(e) => this.setFilterValueToState('has_classification', e.target.value)}
                  value={has_classification || ''}
                  formControlClassName={classes.filterInput}
                />
              </div>

              <div className={`${classes.alignCenter} ${classes.mb5}`}>
                <span className={classes.filterItemLabel}>has_completion</span>
                <TrplSelect
                  margin="none"
                  complicatedValues
                  values={[
                    { title: '', value: '' },
                    { title: 'false', value: false },
                    { title: 'true', value: true },
                  ]}
                  onChange={(e) => this.setFilterValueToState('has_completion', e.target.value)}
                  value={has_completion}
                  formControlClassName={classes.filterInput}
                />
              </div>

              <div className={`${classes.alignCenter} ${classes.mb5}`}>
                <span className={classes.filterItemLabel}>gpt_classification</span>
                <TrplSelect
                  margin="none"
                  stylesToItems={
                    {
                      'none': {fontStyle: 'italic', fontWeight: 550 },
                      'any': {fontStyle: 'italic', fontWeight: 550 },
                    }
                  }
                  values={['', 'none', 'any', ...finetune_classif]}
                  onChange={(e) => this.setFilterValueToState('has_gpt_classification', e.target.value)}
                  value={has_gpt_classification}
                  formControlClassName={classes.filterInput}
                />
              </div>

              <div className={`${classes.alignCenter} ${classes.mb5}`}>
                <span className={classes.filterItemLabel}>has_gpt_completion</span>
                <TrplSelect
                  margin="none"
                  complicatedValues
                  values={[
                    { title: '', value: '' },
                    { title: 'false', value: false },
                    { title: 'true', value: true },
                  ]}
                  onChange={(e) => this.setFilterValueToState('has_gpt_completion', e.target.value)}
                  value={has_gpt_completion}
                  formControlClassName={classes.filterInput}
                />
              </div>

              <div className={`${classes.alignCenter} ${classes.mb10}`}>
                <span className={classes.filterItemLabel}>has_attachments</span>
                <TrplSelect
                  margin="none"
                  complicatedValues
                  values={[
                    { title: '', value: '' },
                    { title: 'false', value: false },
                    { title: 'true', value: true },
                  ]}
                  onChange={(e) => {
                    this.setFilterValueToState('has_attachments', e.target.value);
                  }}
                  value={has_attachments}
                  formControlClassName={classes.filterInput}
                />
              </div>

              <div className={`${classes.mt10} ${classes.justifyEnd}`} style={{ alignSelf: 'end' }}>
                <button
                  size="small"
                  className={`${classes.btn} ${classes.btnGray}`}
                  style={{
                    textTransform: 'capitalize',
                  }}
                  onClick={() => {
                    this.setState({ isDataLoading: true });
                    this.onSendFilterBtnClick();
                  }}
                >
                  {isDataLoading ? <LoaderNew /> : 'Get'}
                </button>
              </div>
            </div>

            <div className={`${classes.ml20} ${classes.p10}`} style={{ backgroundColor: '#d0d3e2' }}>
              <div className={`${classes.alignCenter} ${classes.mt5}`}>
                <span className={classes.filterItemLabel}>is_json_valid</span>
                <TrplSelect
                  margin="none"
                  complicatedValues
                  values={[
                    { title: '', value: '' },
                    { title: 'false', value: false },
                    { title: 'true', value: true },
                  ]}
                  onChange={(e) => {
                    this.setFilterValueToState('is_json_valid', e.target.value);
                  }}
                  value={is_json_valid}
                  formControlClassName={classes.filterInput}
                />
              </div>

              <div className={`${classes.alignCenter} ${classes.mt5}`}>
                <span className={classes.filterItemLabel}>has_table</span>
                <TrplSelect
                  margin="none"
                  complicatedValues
                  values={[
                    { title: '', value: '' },
                    { title: 'false', value: false },
                    { title: 'true', value: true },
                  ]}
                  onChange={(e) => {
                    this.setFilterValueToState('has_table', e.target.value);
                  }}
                  value={has_table}
                  formControlClassName={classes.filterInput}
                />
              </div>

              <div className={classes.alignCenter}>
                <div className={`${classes.mt10}`}>
                  <div className={`${classes.alignCenter}`}>
                    <span className={classes.filterItemLabel}>old key</span>
                    <input
                      value={old_key}
                      name="old_key"
                      className={`${classes.filterInput}`}
                      onChange={(e) => {
                        this.setFilterValueToState('old_key', e.target.value);
                      }}
                    />
                  </div>

                  <div className={`${classes.alignCenter} ${classes.mt5}`}>
                    <span className={classes.filterItemLabel}>new key</span>
                    <input
                      value={new_key}
                      name="new_key"
                      className={`${classes.filterInput}`}
                      onChange={(e) => {
                        this.setFilterValueToState('new_key', e.target.value);
                      }}
                    />
                  </div>
                </div>

                <div className={`${classes.justifyEnd} ${classes.ml10}`}>
                  <button
                    size="small"
                    className={`${classes.btn} ${classes.btnGray}`}
                    style={{
                      textTransform: 'capitalize',
                    }}
                    onClick={() => {
                      this.setState({ isChangingFinetuneKey: true }, () => this.changeFinetuneKey());
                    }}
                  >
                    {isChangingFinetuneKey ? <LoaderNew /> : 'Change'}
                  </button>
                </div>
              </div>

              <div className={`${classes.alignCenter} ${classes.mt10}`}>
                <span className={classes.filterItemLabel}>all macro search</span>
                <textarea
                  value={searchValue}
                  style={{ maxWidth: '500px', maxHeight: '500px', minWidth: '255px' }}
                  className={`${classes.filterTextarea}`}
                  onChange={(e) => {
                    this.setSearchVal(e.target.value);
                  }}
                />
              </div>

              <div className={`${classes.alignCenter} ${classes.mt10}`}>
                <span className={classes.filterItemLabel}>classif stat</span>
                <textarea
                  value={classif_stat || ''}
                  style={{ maxWidth: '500px', maxHeight: '500px', minWidth: '255px', minHeight: '200px' }}
                  className={`${classes.filterTextarea}`}

                />

                <div className={`${classes.justifyEnd} ${classes.ml10}`}>
                  <button
                    size="small"
                    className={`${classes.btn} ${classes.btnGray}`}
                    style={{
                      textTransform: 'capitalize',
                    }}
                    onClick={() => {
                      this.setState({ isClassifStatLoading: true }, () => this.getClassifStat());
                    }}
                  >
                    {isClassifStatLoading ? <LoaderNew /> : 'Get'}
                  </button>
                </div>
              </div>
            </div>
          </div>

          <div className={`${classes.ml20}`}>
            <div className={`${classes.mb10} ${classes.p10}`} style={{ backgroundColor: '#fff' }}>
              <a target="_blank" rel="noreferrer" href={'/run_finetune_analytics?show_all=0&details=0'} className={classes.m10}>
                {'/run_finetune_analytics?show_all=0&details=0'}
              </a>
            </div>

            <div className={`${classes.mb10} ${classes.p10}`} style={{ backgroundColor: '#fff' }}>
              <a target="_blank" rel="noreferrer" href={'/find_finetunes_by_query?q=/pickup/0/items/0/weight_each'} className={classes.m10}>
                {'/find_finetunes_by_query?q=/pickup/0/items/0/weight_each'}
              </a>
            </div>

            <div className={`${classes.mb10} ${classes.p10}`} style={{ backgroundColor: '#fff' }}>
              <a target="_blank" rel="noreferrer" href={'/openai/finetune_events?fineTuneId='} className={classes.m10}>
                {'/openai/finetune_events?fineTuneId='}
              </a>
            </div>

            <div className={`${classes.p10} ${classes.mb10}`} style={{ backgroundColor: '#fff' }}>
              <a target="_blank" rel="noreferrer" href={'/openai/get_file_content?fileId='} className={classes.m10}>
                {'/openai/get_file_content?fileId='}
              </a>
            </div>

            <div className={`${classes.p10}`} style={{ backgroundColor: '#fff' }}>
              <a
                target="_blank"
                rel="noreferrer"
                href={'/openai/upload_file?upload=false&validPercent=0&startId=0&lastId=0'}
                className={classes.m10}
              >
                {'/openai/upload_file?upload=false&validPercent=0&startId=0&lastId=0'}
              </a>
            </div>
          </div>
        </div>

        {messagesData && messagesData.length && lastSentData ?
          <div
            className={`${classes.m10} ${classes.alignCenter}`}
            style={{ width: '70vw', marginLeft: '30px' }}
          >
            {/* {[...Array(total_msgs), ''].map((element, number) => {
              return (
                <React.Fragment key={number}>
                  {number === lastSentData.first_index && lastSentData.first_index !== 0 ?
                    <span
                      key={'first_' + lastSentData.first_index}
                      className={`${classes.justifyEnd} ${classes.nowrap}`}
                      style={{ marginTop: '20px', fontSize: 11, color: '#4C4C4C', width: '0px' }}>
                      {number} first index
                    </span>
                  : null}

                  <div
                    className={classes.alignCenter}
                    style={{
                      height: '3px',
                      width: total_msgs > 10000 ? `calc(70vw / (${total_msgs}/100))` :
                        total_msgs > 1000 ? `calc(70vw / (${total_msgs}/10))` :
                        `calc(70vw / ${total_msgs})`,
                      backgroundColor: ((number < lastSentData.first_index) ? '#FFFF'
                        : (number > (lastSentData.first_index + lastSentData.limit)) ? '#FFFF' : '#DD5900'),
                    }}>
                  </div>

                  {(number > lastSentData.first_index) && (number < (frontFilteredMsgsData.length + lastSentData.first_index))
                    && ((frontFilteredMsgsData.length + lastSentData.first_index) !== total_msgs) ?
                    <div
                      className={classes.alignCenter}
                      style={{
                        height: '3px',
                        width: total_msgs > 10000 ? `calc(70vw / (${total_msgs}/100))` :
                          total_msgs > 1000 ? `calc(70vw / (${total_msgs}/10))` :
                          `calc(70vw / ${total_msgs})`,
                        backgroundColor: ((number < (frontFilteredMsgsData.length + lastSentData.first_index))
                          && (frontFilteredMsgsData.length + lastSentData.first_index) !== total_msgs) ? '#D9D8ED'
                          : '#EEECF8',
                      }}>
                    </div>
                  : null}

                  {frontFilteredMsgsData.length !== total_msgs && number === (lastSentData.first_index) ?
                    <span
                      key={'add_' + frontFilteredMsgsData.length}
                      className={classes.nowrap}
                      style={{ marginTop: '-20px', fontSize: 11, width: '0px', color: '#4C4C4C' }}>
                      {frontFilteredMsgsData.length} {`${frontFilteredMsgsData.length > 1 ? 'messages are shown' : 'message is shown'}`}
                    </span>
                  : null}

                  {number === (lastSentData.first_index + lastSentData.limit) ?
                    <span
                      key={'last_' + lastSentData.first_index + lastSentData.limit}
                      className={classes.nowrap}
                      style={{ marginTop: '20px', fontSize: 11, color: '#4C4C4C', width: '0px'}}>
                        {lastSentData.limit} limit
                    </span>
                  : null}
                </React.Fragment>
              )
            })} */}
            <span
              className={`${classes.nowrap} ${classes.ml10}`}
              style={{ marginBottom: '2px', fontSize: 11, color: '#4C4C4C' }}
            >
              total messages: {total_msgs}
            </span>
            {frontFilteredMsgsData && frontFilteredMsgsData.length ?
              <span
                className={`${classes.nowrap} ${classes.ml10}`}
                style={{ marginBottom: '2px', fontSize: 11, color: '#4C4C4C' }}
              >
                shown: {frontFilteredMsgsData.length}
              </span>
            : null}
          </div>
        : null}

        <div id='parentContainer' style={{ width: '100%' }}>
          {!isDataLoading && frontFilteredMsgsData.length ? frontFilteredMsgsData.map((message, index) => {
            const messageInitial= messagesData && messagesData.find(mes => mes.id === message.id);
            const highlightAsNotValid = messageInitial ? ((!messageInitial.is_finetune_compl_valid && messageInitial.finetune_compl) ? true : false) : false;

            return (
              <div key={message.id} className={`${classes.mt20}`}>
                <DataAndMacro
                  index={index + 1}
                  classes={classes}
                  message={message}
                  llm_models={llm_models}
                  searchValue={searchValue}
                  countTokens={this.countTokens}
                  finetune_classif={finetune_classif}
                  finetune_template={finetune_template}
                  onSaveJsonToDB={this.onSaveJsonToDB}
                  modifyJsonKeyVal={this.modifyJsonKeyVal}
                  highlightAsNotValid={highlightAsNotValid}
                  sendClassification={this.sendClassification}
                />
              </div>
            )
          }) : <span className={classes.nothingFoundText}>Nothing to show</span>}
        </div>
      </div>
    )
  }
};

export default withStyles(styles)(FineTuningDatasetPage);
